import { Menu, MenuItem } from "@mui/material"
import { MenuListStyled, MenuPaperStyled } from "./style";
import { IconTeams } from "../../../icons/IconTeams";
import { IconGrowthTools } from "../../../icons/IconGrowthTools";
import { useLocation, useNavigate } from "react-router-dom";
import { routesProfile } from "../../../consts";

interface UserAccountMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const BottomNavMenu = ({ anchorEl, onClose }: UserAccountMenuProps) => {
    const open = Boolean(anchorEl)
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const paths = {
        teams: `/${routesProfile.TEAMS.path}`,
        growthTools: `/${routesProfile.GROWTHTOOLS.path}`,
    };
    const handleItemClick = (path: string) => {
        navigate(path);
        onClose();
    };

    return(
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            slotProps={{
                paper: {
                    sx: MenuPaperStyled,
                },
                list: {
                    disablePadding: true,
                    sx: MenuListStyled,
                }
            }}
        >
            <MenuItem onClick={() => handleItemClick(paths.teams)} selected={pathname === paths.teams}>
                <IconTeams fontSize="medium" />
                Команды
            </MenuItem>
            <MenuItem onClick={() => handleItemClick(paths.growthTools)} selected={pathname === paths.growthTools}>
                <IconGrowthTools fontSize="medium" />
                Инструменты
            </MenuItem>
        </Menu>
    )
}
